import React from "react";
import { graphql } from "gatsby";
import Layout from "../other/layout";
import CategoryPage from "../components/OFB-Category/Category";

import SEO from "../other/seo";
import { PROJECT_LINK, SOLE_PROJECT_LINK } from "../project-config";

export const query = graphql`
  query MyQuery2($url: [String]) {
    allAvettiMenu {
      nodes {
        childs {
          name
          vid
          cid
          thumbnail
          image
          position
          description
          metadescription
          metakeywords
          URL
          childs {
            name
            vid
            cid
            thumbnail
            image
            position
            description
            metadescription
            metakeywords
            URL
          }
        }
      }
    }
    allAvettiCategory(filter: { url: { in: $url } }) {
      nodes {
        cid
        url
        name
        image
        itemsCount
        numberOfPages
        description
        itemsFirstPage {
          id
          title
          code
          desc
          currency_sign
          image
          itemLargeImage
          price {
            value {
              integer
              decimal
            }
          }
          prices {
            packagePrices {
              price
              quantity
            }
            itemcode
            priceLabel
            price_1
          }
          url
        }
        facets {
          Price {
            count
            removeText
            text
            value
          }
          Reviews {
            removeText
            count
            text
            value
          }
          Other {
            facetValues {
              count
              name
              removeText
              text
              value
            }
            title
            name
          }
        }
      }
    }
  }
`;
const Category = ({ data, pageContext }) => {
  const name = data.allAvettiCategory.nodes[0].name;
  const meta = data.allAvettiCategory.nodes[0].meta;
  const image = data.allAvettiCategory.nodes[0].image;
  // console.info("DATA HERE", data.allAvettiCategory.nodes[0]);
  const imageUrl = `${PROJECT_LINK}/store/${image}`;
  const allMenus = data.allAvettiMenu.nodes[0].childs;
  const navCategory = data.allAvettiMenu.nodes[0].childs.filter(
    chil =>
      chil.URL.replace("shop/", "") === data.allAvettiCategory.nodes[0].url
  )[0];

  return (
    <Layout>
      <SEO
        lang={"en"}
        title={name}
        pathname={data.allAvettiCategory.nodes[0].url}
        meta={[
          {
            name: `og:image`,
            content: imageUrl
          },
          {
            name: `og:image:secure_url`,
            content: imageUrl
          },
          {
            name: `twitter:image`,
            content: imageUrl
          },

          {
            name: `og:url`,
            content: `${SOLE_PROJECT_LINK}/${data.allAvettiCategory.nodes[0].url}`
          }
        ]}
      />
      {data.allAvettiCategory.nodes[0].name === "Sellers" ? null : (
        <CategoryPage
          data={data.allAvettiCategory.nodes[0]}
          pageContext={pageContext}
          navCategory={navCategory}
          supplier={[]}
          allMenus={allMenus}
        />
      )}
    </Layout>
  );
};

export default Category;
